import React from "react";
import { Form, Select } from "antd";

const { Option } = Select;

const YesOrNoToggleInput = ({ name, label, disabled }) => {
  return (
    <Form.Item name={name} label={label}>
      <Select disabled={disabled}>
        <Option key="yes" value={true}>
          Yes
        </Option>
        <Option key="no" value={false}>
          No
        </Option>
      </Select>
    </Form.Item>
  );
};

export default YesOrNoToggleInput;
